// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "warning-1rBc5";
var _4 = "warning__trigger-3fvWe";
var _5 = "warning__title-3gLax";
var _6 = "warning__text-1zTO6";
var _7 = "warning__arrow-18z3M";
var _8 = "warning__arrow_rotated-2kwvm";
export { _1 as "__esModule", _2 as "mobile", _3 as "warning", _4 as "warning__trigger", _5 as "warning__title", _6 as "warning__text", _7 as "warning__arrow", _8 as "warning__arrow_rotated" }
export default { "__esModule": _1, "mobile": _2, "warning": _3, "warning__trigger": _4, "warning__title": _5, "warning__text": _6, "warning__arrow": _7, "warning__arrow_rotated": _8 }
